export enum ApprovedAuthorizationOption {
  All = "All",
  Yes = "Yes",
  No = "No"
}
